import React from 'react'

import LinePenIcon from 'components/Luxkit/Icons/line/LinePenIcon'
import LineSettingIcon from 'components/Luxkit/Icons/line/LineSettingIcon'
import LineTrashAltIcon from 'components/Luxkit/Icons/line/LineTrashAltIcon'
import ListItem from 'components/Luxkit/List/ListItem'
import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import DeleteTripItem from 'tripPlanner/components/TripModal/TripItems/DeleteTripItem'
import EditTripItem from 'tripPlanner/components/TripModal/TripItems/Edit'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { ItemMetadata } from 'tripPlanner/models'
import { TripItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isCustomItem } from 'tripPlanner/utils'

interface Props {
  item: TripItem
}

export default function ItemMenuOptions(props: Props) {
  const { item } = props

  const openModal = useOpenModal()

  const canShowEdit = isCustomItem(item) && ItemMetadata[item.type].editable

  const orderId = getOrderId(item)
  const userId = useAppSelector(getCurrentUserId)

  return (
    <>
      {canShowEdit && (
        <ListItem
          startIcon={<LinePenIcon size="S" />}
          onClick={() => openModal(EditTripItem, { item })}
          title="Edit"
        />
      )}
      {orderId && item.createdBy === userId && (
        <ListItem
          startIcon={<LineSettingIcon size="S" />}
          title="Manage booking"
          to={`/account/my-escapes/order/${orderId}`}
          target="_blank"
        />
      )}
      <ListItem
        startIcon={<LineTrashAltIcon size="S" />}
        onClick={() => openModal(DeleteTripItem, { item }, { height: 'auto' })}
        title="Delete from trip"
      />
    </>
  )
}
